import {lazy, Suspense, useState} from 'react'

import PropTypes from 'prop-types'

import {atomButtonShapes} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import MoleculeSelectPopover from '@s-ui/react-molecule-select-popover'
import ChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'

import {BASE_CLASS} from '../../config.js'
import SelectPopoverModalContentWrapper from '../SelectPopoverModalContentWrapper/index.js'

const LazyFormLocationAutosuggest = lazy(() => import('../AutosuggestLoader/index.js'))

const ModalAutosuggest = ({aggregations, isLoading, onChange, value}) => {
  const [forceClosePopover, setForceClosePopover] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {i18n} = useSuiContext()

  const handleOpenSelectPopover = () => {
    setIsModalOpen(true)
    setForceClosePopover(false)
  }

  const handleSelectLocation = ({lat, long, text, provinceId}) => {
    onChange({lat, long, text, provinceId})
    if (text) {
      setForceClosePopover(true)
      setIsModalOpen(false)
    }
  }

  return (
    <MoleculeSelectPopover
      acceptButtonOptions={{isLoading, shape: atomButtonShapes.CIRCULAR}}
      acceptButtonText={i18n.t('COMMON.ACCEPT')}
      cancelButtonOptions={{shape: atomButtonShapes.CIRCULAR}}
      cancelButtonText={i18n.t('COMMON.CANCEL')}
      forceClosePopover={forceClosePopover}
      fullWidth
      iconArrowDown={ChevronDown}
      onClose={() => setIsModalOpen(false)}
      onOpen={handleOpenSelectPopover}
      renderContentWrapper={SelectPopoverModalContentWrapper}
      selectText={value || 'Todas las ubicaciones'}
    >
      <Suspense fallback={<></>}>
        {isModalOpen && (
          <div className={`${BASE_CLASS}Popover-wrapper`}>
            <LazyFormLocationAutosuggest
              aggregations={aggregations}
              autoFocus
              isLoading={isLoading}
              onChange={handleSelectLocation}
              value={value}
            />
          </div>
        )}
      </Suspense>
    </MoleculeSelectPopover>
  )
}

ModalAutosuggest.displayName = 'ModalAutosuggest'

ModalAutosuggest.propTypes = {
  aggregations: PropTypes.array,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object
}

export default ModalAutosuggest
